<template>
  <div>
    <div class="vilocal-root" v-loading="dataLoading">
      <div class="slogan-row">
        <div>
          <div class="slogan">Continuous new arrivals, curated by ViLocal!</div>
          <div v-if="!isMobile" class="black-line"></div>
        </div>
        <div class="search-box" v-if="!isMobile" ref="searchBox">
          <el-input  v-model="searchInput" prefix-icon="el-icon-search"  @focus="focusHandle"
             placeholder="Search for the brands and products you are interested in"
            clearable @change="changeHandle"></el-input>
        </div>
      </div>
      <div class="horizontal-divider">
      <div class="grey-line"></div>
    </div>
    <div class="search-box" v-if="isMobile" ref="searchBox">
      <el-input  v-model="searchInput" prefix-icon="el-icon-search" @change="changeHandle" @focus="focusHandle"
         placeholder="Search for the brands and products you are interested in"
        clearable></el-input>
    </div>
    <!-- <div v-if="isShowBrandType" class="menu-swiper-div">
      <div v-if="!isMobile" v-for="(item,index) in brandTypeList" :key="index" :class="item.value === brandType?'menu-checked':'menu'" @click="searchReuslt(item.value,item.label)">
          {{item.label}}
      </div>
      <swiper v-if="isMobile" ref="swiper3" :options="appWarehousesSwiperOption">
        <swiper-slide v-for="(item,key) in brandTypeList" :key="key" :class="item.value === brandType?'menu-checked':'menu'" >
          <div @click="searchReuslt(item.value,item.label)">{{item.label}}</div>
        </swiper-slide>
      </swiper>
    </div> -->

    <div class="card-container" v-if="localStoreList && localStoreList.length>0">
      <div class="vilocal-card card" v-for="(item, index) in localStoreList" :key="index" :ref="index">
        <div class="goods">
          <div class="discount-tag" v-if="item.vilocalType!==4">
            100% OFF
          </div>
          <div class="discount-tag" v-else>
            {{(item.discountTrialRate*100).toFixed(0)}}% OFF
          </div>

          <div class="card-detail-swiper">
            <img class="card-img" v-if="item.goodsList.length == 1" @click="toGoodsDetail(item.goodsList[0].seoUrl,item.goodsList[0])"
              :src="item.goodsList[0].spuImg" />
            <div v-if="item.goodsList.length == 1" class="price">
              <span class="live-price">{{ Number(item.vilocalType!==4?0:item.goodsList[0].discountTrialWholeSalePrice).toLocaleString('en-US', {
                style: 'currency', currency: 'USD'
              }) }}</span>
              <span class="original-price"> {{ Number(item.goodsList[0].wholeSalePrice).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
              }) }}</span>
              Wholesale Price
            </div>

            <swiper v-else class="swiper pcSwiper2" @slideChange="handleSlideChange(item)" :ref="getRefName(item.collectionBrandId)" :options="localStoreSwiperOption">
              <i class="el-icon-arrow-left smail-img-swiper-prev" slot="button-prev" @click="leftClick(item)"></i>
              <swiper-slide v-for="(img, key) in  item.goodsList" :key="key" ref="swiperImg">
                <div class="card-detail">
                  <div class="img-detail">
                    <img class="card-img" @click="toGoodsDetail(img.seoUrl,img)" :src="img.spuImg">
                  </div>
                  <div class="price">
                    <span class="live-price">{{ Number(item.vilocalType!==4?0:img.discountTrialWholeSalePrice).toLocaleString('en-US', {
                      style: 'currency', currency: 'USD'
                    }) }}</span>
                    <span class="original-price"> {{ Number(img.wholeSalePrice).toLocaleString('en-US', {
                      style: 'currency',
                      currency: 'USD'
                    }) }}</span>
                    Wholesale Price
                  </div>
                </div>
              </swiper-slide>
              <i class="el-icon-arrow-right smail-img-swiper-next" slot="button-next" @click="rightClick(item)"></i>
            </swiper>

          </div>
          <div class="wholesale-static-circle-completed" v-if="item.vilocalStatus === 2">
            <div class="wholesale-static-circle-completed-text" v-if="item.vilocalStatus === 2">Completed</div>
          </div>
          <div class="action-area" v-if="item.goodsList.length == 1">
            <!-- 用户不存在viLocal订单时 且 viLocal状态是进行中，不登录情况下默认是不存在viLocal订单 -->
            <h4 v-if="item.vilocalStatus === 0 && !isExitsViLocalOrder" class="wholesale-static"  @click="oneClickOrder(item.collectionBrandId,item)">
              Get ViLocal Order
            </h4>
            <!-- 用户不存在viLocal订单时 且 viLocal状态是未开始，不登录情况下默认是不存在viLocal订单 -->
            <h4 v-if="item.vilocalStatus === 1 && !isExitsViLocalOrder" class="wholesale-static-pre-order"  @click="oneClickOrder(item.collectionBrandId,item)">
              Pre-Order
            </h4>
            <h4 v-if="item.vilocalStatus === 2" class="wholesale-static-completed"  @click="oneClickOrder(item.collectionBrandId,item)">
              Waiting to Reopen
            </h4>
            <!-- 不管是 未开始还是进行中，只要存在viLocal订单 就都是一个提示 -->
            <h4 v-if="(item.vilocalStatus === 0 || item.vilocalStatus === 1) && isExitsViLocalOrder" class="wholesale-static-placed"  >
              ViLocal order placed
            </h4>
          </div>
          <div class="action-area" v-else>
            <!-- 用户不存在viLocal订单时 且 viLocal状态是进行中，不登录情况下默认是不存在viLocal订单 -->
            <h4 v-if="item.vilocalStatus === 0 && !isExitsViLocalOrder" class="wholesale"  @click="oneClickOrder(item.collectionBrandId,item)">
              Get ViLocal Order
            </h4>
            <!-- 用户不存在viLocal订单时 且 viLocal状态是未开始，不登录情况下默认是不存在viLocal订单 -->
            <h4 v-if="item.vilocalStatus === 1 && !isExitsViLocalOrder" class="wholesale-pre-order"  @click="oneClickOrder(item.collectionBrandId,item)">
              Pre-Order
            </h4>
            <h4 v-if="item.vilocalStatus === 2" class="wholesale-completed"  @click="oneClickOrder(item.collectionBrandId,item)">
              Waiting to Reopen
            </h4>
            <!-- 不管是 未开始还是进行中，只要存在viLocal订单 就都是一个提示 -->
            <h4 v-if="(item.vilocalStatus === 0 || item.vilocalStatus === 1) && isExitsViLocalOrder" class="wholesale-placed">
              ViLocal order placed
            </h4>
          </div>
        </div>
        <div class="vilocal-type-tips">{{item.vilocalTypeTips}}</div>
        <div class="vilocal-info">
          <div class="brand">
            <img class="brand-logo" @click="toBrandDetail(item.collectionBrandSeoUrl,item)" :src="item.brandLogoUrl" />
            <p class="brand-name" @click="toBrandDetail(item.collectionBrandSeoUrl,item)">{{ item.collectionBrandName }}</p>
          </div>

          <div class="vilocal-progress">
            <div class="progress-info-bar">
              <div class="progress-info" :style="{
                left: `${calculateInfoOffset(item.vilocalProgressPercentage)}px`
              }">{{ item.vilocalProgressPercentage }}% to go</div>
              <div class="triangle" :style="{
                left: `${calculateArrowOffset(item.vilocalProgressPercentage)}px`
              }"></div>
            </div>

            <el-progress class="progress" color="#262613" :percentage="item.vilocalProgressPercentage"
              :show-text="false"></el-progress>
          </div>
        </div>
      </div>
    </div>
    <div class="no-data-container" v-else>
      <img class="no-data-img" src="@/assets/img/vilocal/vilocal-dialog-img.png">
      <div class="no-data-info">No results found</div>
      <div class="no-data-btn" @click="noDataBtnGetList">Back</div>
    </div>
    </div>
    <PageCom :currentPage="pageNo" class="pageSize page" :total="total" :pageSize="pageSize"
      @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :pageOptions="options"></PageCom>
  </div>
</template>

<script>

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import '../home/swiper3.1.3.css'
import PageCom from '../components/pagination-new.vue'
import { getAction, postAction } from '@/api/manage.js'
import MugenScroll from 'vue-mugen-scroll'
import {buryingPoint} from '../../utils/log'

export default {
  name: 'vilocalProduct',
  components: {
    swiper,
    swiperSlide,
    PageCom,
    MugenScroll
  },
  props: {
    isExitsViLocalOrder: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dataLoading: false,
      activeIndex: '1',
      appWarehousesSwiperOption: {
        slidesPerView: 2,
        spaceBetween: 0
      },
      searchInput: '',
      loading: false,
      localStoreList: [],
      localStoreSwiperOption: {
        loop: true,
        direction: 'horizontal',
        navigation: {
          nextEl: '.smail-img-swiper-next',
          prevEl: '.smail-img-swiper-prev'
        },
        on: {
          click: (e) => {
            // console.log(e,"|>|")
          },
          slideChange: (e) => {
            // 滑块改变时
          }
        }
      },
      progressInner: 0,
      arrowOffset: 0,
      total: 0,
      options: [60, 120, 150, 180],
      value: 20,
      pageSize: 60,
      pageNo: 1,
      hasMoreShopping: false,
      brandTypeList: [
        {label: 'Supply Showcase', value: 2},
        {label: 'Boutique Selection', value: 1},
        {label: 'Everyday Essentials', value: ''}
      ],
      brandType: 2,
      isShowBrandType: true
    }
  },
  methods: {
    searchReuslt(brandType, brandLable) {
      // 切换tab的时候要 更新第一页
      this.brandType = brandType
      mixpanel.track('c_' + brandLable)
      this.pageNo = 1
      this.queryBrand(this.searchInput)
    },
    queryBrand(value) {
      if (this.dataLoading) {
        return
      }
      this.dataLoading = true
      if (value && value !== '') {
        // 如果搜索关键字有值，那么就做隐藏brandType切换，并且不带brandType参数查询
        this.brandType = ''
        this.isShowBrandType = false
      } else {
        this.isShowBrandType = true
      }
      mixpanel.track('vilocal_search', {keywords: value})
      if (value === '') {
        this.$emit('show-review', true)
      } else {
        this.$emit('show-review', false)
      }
      this.localStoreList = []
      getAction(`/vilocal/api/v0.2/list?pageNo=${this.pageNo}&pageSize=${this.pageSize}&keyWords=${value}&vilocalType=${this.brandType}`).then((res) => {
        if (res.code === 200) {
          this.dataLoading = false
          if (res.result == null || res.result == undefined) {
            this.localStoreList = []
            this.total = 0
            this.pageSize = 60
            this.pageNo = 1
          } else {
            let data = res.result.records
            for (let item of data) {
              item.vilocalTypeTips = ''
              // add by cpgu 2023/07/18 添加一个索引字段i begin
              if (item['goodsList']) {
                for (let i = 0, len = item['goodsList'].length; i < len; i++) {
                  item['goodsList'][i]['i'] = i
                }
              }
              if (item.vilocalStatus === 2) {
                item.vilocalProgressPercentage = 0
              }
              if (item.vilocalStatus === 1 && !this.login) {
                item.vilocalProgressPercentage = 100
              }
              // end by cpgu
              // 2.2.6 vilocal寄售版本
              if (item.isOldVilocalBrand) {
                // 如果是老的vilocal 直接显示打包
                item.vilocalTypeTips = 'Free trial set '
                if (item.vilocalStatus === 2) {
                  item.vilocalTypeTips = 'Trial ended. Explore other items'
                }
              } else {
                const freeTrialSkuCount = item.freeTrialSkuCount
                const consignSkuCount = item.consignSkuCount
                const discountTrialSkuCount = item.discountTrialSkuCount
                const vilocalTypeBrand = item.vilocalTypeBrand
                // 如果是试销并且试销数量大于0显示
                if (vilocalTypeBrand === 1) {
                  if (freeTrialSkuCount > 0) {
                    item.vilocalTypeTips = 'Free trial for ' + freeTrialSkuCount + ' Set'
                    if (freeTrialSkuCount > 1) {
                      item.vilocalTypeTips = item.vilocalTypeTips + 's'
                    }
                  } else {
                    item.vilocalTypeTips = 'Trial ended. Explore other items'
                  }
                } else if (vilocalTypeBrand === 2) {
                  if (consignSkuCount > 0) {
                    item.vilocalTypeTips = 'Free returns for ' + consignSkuCount + ' Set'
                    if (consignSkuCount > 1) {
                      item.vilocalTypeTips = item.vilocalTypeTips + 's'
                    }
                  } else {
                    item.vilocalTypeTips = 'Trial ended. Explore other items'
                  }
                } else if (vilocalTypeBrand === 3) {
                  if (freeTrialSkuCount > 0) {
                    item.vilocalTypeTips = 'Free trial for ' + freeTrialSkuCount + ' Set'
                    if (freeTrialSkuCount > 1) {
                      item.vilocalTypeTips = item.vilocalTypeTips + 's'
                    }
                  }
                  if (consignSkuCount > 0) {
                    if (item.vilocalTypeTips === '') {
                      item.vilocalTypeTips = 'Free returns for ' + consignSkuCount + ' Set'
                    } else {
                      item.vilocalTypeTips = item.vilocalTypeTips + ', Free returns for ' + consignSkuCount + ' Set'
                    }
                    if (consignSkuCount > 1) {
                      item.vilocalTypeTips = item.vilocalTypeTips + 's'
                    }
                  }
                  if (freeTrialSkuCount <= 0 && consignSkuCount <= 0) {
                    item.vilocalTypeTips = 'Trial ended. Explore other items'
                  }
                }else if(vilocalTypeBrand === 4) {
                  item.vilocalTypeTips = 'Trial ended. Explore other items'
                  if (discountTrialSkuCount > 0) {
                    item.vilocalTypeTips = `${Number(item.discountTrialRate*100).toFixed(0)}% off trial for ${discountTrialSkuCount} Set${discountTrialSkuCount>1?'s':''}`
                  }
                }
              }
            }
            this.localStoreList = res.result.records
            this.total = res.result.total
            this.pageSize = res.result.size
            this.pageNo = res.result.current
            this.$nextTick(() => {
              this.progressInner = document.querySelector('.vilocal-progress')
              this.arrowOffset = this.progressInner.offsetWidth
            })
          }
        }
      }).catch((err) => {
        this.dataLoading = false
        console.error(err)
      })
    },
    changeHandle() {
      this.pageNo = 1 // 关键词更换时页码初始化
      this.blurHandle()
    },
    blurHandle() {
      this.focus = false
      // 2.1.8 清空关键字，tab默认切换第一个supply
      if (this.searchInput === '') {
        this.brandType = 2
      }
      this.queryBrand(this.searchInput)
      if (this.searchInput !== '') {
        this.queryBrand(this.searchInput)
        buryingPoint(38, '', this.searchInput, '')
      }
    },
    focusHandle() {
      this.focus = true
      if (this.searchInput !== '') {
        // this.queryBrand(this.searchInput)
      }
      console.log(this.focus)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNo = 1

      this.queryBrand(this.searchInput)
    },
    handleCurrentChange(val) {
      this.pageNo = val
      window.scrollTo({
        top: 0
      })
      this.queryBrand(this.searchInput)
    },
    oneClickOrder(brandId, itm) {
      mixpanel.track('vilocal_button_3', {button_name: 'Get free trial sales NOW!'})
      if (this.login) {
        let userInfo = JSON.parse(localStorage.getItem('pro__userInfo'))
        let userId = userInfo.value.id
        if (itm.vilocalStatus !== 2) {
          // 如果登录了，点击跳转到vilocal
          this.createVilocalOrder(userId, brandId)

          // // 不存在首单再调用接口获取商品审核信息
          // if (!this.isExitsViLocalOrder) {
          //   // 2.0.8 vilocal-v5 新增部分 statr  先判断是否是
          //   getAction(`/store/api/v0.2/shops/users/${userId}/status`).then(response => {
          //     if (response.success) {
          //       // 返回值为false 否的话再跳转到checkout，否则需要跳转到新页面
          //       if (!response.result) {
          //         // 2.0.8 vilocal-v5 新增部分 end
          //         this.createVilocalOrder(userId, brandId)
          //       } else {
          //         // 跳转到店铺审核页面 并且要把品牌ID加到缓存中
          //         // 每次点击都将vilocalBrand 删除重新赋值
          //         this.$ls.remove('vilocalBrand')
          //         // 如果状态不为2 则调用
          //         if (itm.vilocalStatus !== 2) {
          //           this.$ls.set('vilocalBrand', brandId)
          //         }
          //         this.$router.push({path: '/store-info'})
          //       }
          //     } else {
          //       this.$message.warning(response.message)
          //     }
          //   })
          // } else {
          //   // 存在首单直接下单
          //   this.createVilocalOrder(userId, brandId)
          // }
        }
      } else {
        // 每次点击都将vilocalBrand 删除重新赋值
        this.$ls.remove('vilocalBrand')
        // 如果状态不为2 则调用
        if (itm.vilocalStatus !== 2) {
          this.$ls.set('vilocalBrand', brandId)
        }
        this.$emit('handle-scroll')
      }
    },
    createVilocalOrder(userId, brandId) {
      postAction(`/order/api/v0.2/users/${userId}/vi-local-orders?brand_id=${brandId}`).then((res) => {
        if (res.code === 200 && res.result.orderId) {
          // 2.2.2 创建完订单需要跳转到 storeinfo
          this.$router.push({path: '/store-info', query: {orderId: res.result.orderId}})
        } else if (!res.success) {
          this.$message.warning(res.message)
        }
      })
    },
    toGoodsDetail(url, spu) {
      try {
        if (spu && spu['skuInfoList']) {
          let skuArr = spu['skuInfoList'].map(sku => sku['id'])
          buryingPoint(31, spu['goodsId'], spu['skuInfoList'][0]['skuName'], '', JSON.stringify(skuArr))
        }
      } catch (e) {

      }
      // 调用公共方法推送mixpanel
      this.pushMixpanel('vilocal-click-product', spu)

      if (this.isMobile) {
        this.$router.push({ path: '/product' + url })
      } else {
        // PC端 打开新窗口
        window.open(window.location.origin + '/product' + url)
      }
    },
    pushMixpanel(eventName, item) {
      try {
        mixpanel.track(eventName, {message: item})
      } catch (e) {

      }
    },
    toBrandDetail(url, item) {
      //  调用公共方法推送mixpanel
      this.pushMixpanel('vilocal-click-brand', item)
      try {
        let obj = item['goodsList'].map(spu => spu['goodsId'])
        buryingPoint(31, item['collectionBrandId'], item['collectionBrandName'], '', JSON.stringify(obj))
      } catch (e) {

      }
      if (this.isMobile) {
        this.$router.push({ path: '/brand' + url })
      } else {
        // PC端 打开新窗口
        window.open(window.location.origin + '/brand' + url)
      }
    },
    noDataBtnGetList() {
      this.searchInput = ''
      this.brandType = 2
      this.queryBrand(this.searchInput)
    },
    calculateInfoOffset(vilocalProgressPercentage) {
      let percentage = vilocalProgressPercentage >= 70 ? 70 : vilocalProgressPercentage
      let offset = this.arrowOffset * (percentage / 100) - 35

      return offset
    },
    calculateArrowOffset(vilocalProgressPercentage) {
      let percentage = vilocalProgressPercentage >= 85 ? 85 : vilocalProgressPercentage
      let offset = this.arrowOffset * (percentage / 100) - 5

      return offset
    },
    getRefName(id) {
      return `swiper2${id}`
    },
    handleSlideChange(itm) {

    },
    leftClick(itm) {
      if (!itm['i']) {
        itm['i'] = itm['goodsList'].length - 1
      } else if (itm['i'] > 0) {
        itm['i'] = --itm['i']
      } else {
        itm['i'] = itm['goodsList'].length - 1
      }

      let spu = itm['goodsList'][itm['i']]
      if (spu && spu['skuInfoList']) {
        let skuArr = spu['skuInfoList'].map(sku => sku['id'])
        buryingPoint(31, spu['goodsId'], spu['skuInfoList'][0]['skuName'], '', JSON.stringify(skuArr))
      }
    },
    rightClick(itm) {
      if (!itm['i']) {
        itm['i'] = 1
      } else if (itm['i'] < (itm['goodsList'].length - 1)) {
        itm['i'] = ++itm['i']
      } else {
        itm['i'] = 0
      }
      let spu = itm['goodsList'][itm['i']]
      if (spu && spu['skuInfoList']) {
        let skuArr = spu['skuInfoList'].map(sku => sku['id'])
        buryingPoint(31, spu['goodsId'], spu['skuInfoList'][0]['skuName'], '', JSON.stringify(skuArr))
      }
    }
  },
  computed: {
    isMobile() {
      const isMob = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      this.mobile = isMob
      return isMob
    }
  },
  watch: {
    localStoreList: function (newValue, oldValue) {
      if (newValue.length < this.$data.total) {
        this.hasMoreShopping = true
      } else {
        this.hasMoreShopping = false
      }
    }
  },
  created() {
    this.queryBrand(this.searchInput)
    this.$nextTick(() => {
      this.progressInner = document.querySelector('.vilocal-progress')
      this.arrowOffset = this.progressInner.offsetWidth
    })
  },
  mounted() {
    // console.log(this.$ref.swiperImg)
  }
}
</script>

<style scoped lang="less">
// @supports (aspect-ratio: 1) {
//   .card-img {
//     aspect-ratio: 1/1;
//     /* 设置宽高比为1:1 */
//   }
// }
.vilocal-type-tips{
  color: #FB541C;
  font-family: Satoshi-Medium;
  font-size: 14px;
  margin-bottom: 10px;
  margin-top: -10px;
}
/deep/.el-card__body {
  padding: 0;
  border-radius: 0px !important;
}

/deep/ .el-pager li {
  min-width: 28px !important;
}

/deep/ .el-pager li.active {
  color: #fff !important;
  background: #000 !important;
  width: 28px;
  border-radius: 28px;
}

.slogan {
  font-size: 24px;
font-family: Satoshi;
font-weight: bold;
color: #262B2F;
opacity: 1;
}

.card-img {
    cursor: pointer;
    aspect-ratio: 1/1;
    /* 设置宽高比为1:1 */
  }

.slogan-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 25px;
}

.search-box {
  width: 45%;

}

.search-box /deep/ .el-input__inner{
  border-radius:0 !important;
  border: 1px solid #707070;
}

.vilocal-root {
  width: 70%;
  margin: 0 auto;
}

.card-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 20px;
}

.no-data-container{
  display:flex;
  justify-content:center;
  align-items:center;
  flex-direction:column;

  .no-data-img{
    width:56px;
    height:56px;
    margin-top:80px;
  }

  .no-data-info{
    font-size: 14px;
font-family: Satoshi-Medium;
color: #262B2F;
opacity: 1;
margin-top:20px;
  }
  .no-data-btn{
    width: 200px;
height: 40px;
background-color:#262613;
font-size: 14px;
font-family: Satoshi-Medium;
color: #FFFFFF;
display:flex;
justify-content:center;
align-items:center;
margin-top:20px;
cursor:pointer;
  }
}

.vilocal-card {
  width: calc(33.33% - 13.4px);
  //margin: 20px 0px 0px 20px;
  /* 每行渲染3个，减去间距 */
  margin-bottom: 20px;
}

// .vilocal-card:nth-child(3n+1) {
//   margin-left: 0;
//   /* 第一个卡片的左边距设为0 */
// }

// .vilocal-card:last-child {
//   margin-right: 0;
//   /* 最后一个卡片的右边距设为0 */
// }

.card-detail-swiper {
  width: 100%;
}

.horizontal-divider {
  display: flex;
  align-items: center;
  margin: 5px 0px 20px 0px;
}

.black-line {
  width: 100%;
  height: 2px;
  background-color: black;
  position:relative;
  top:8px;
}

.grey-line {
  flex: 1;
  height: 1px;
  background-color: grey;
}

.card-img {}

.goods {
  position: relative;
  width: 100%;
  line-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: calc(100% - 2px);
    // height: calc(100vw -2px);
    object-fit: cover;
    border: 1px solid #eee;
  }
  .wholesale-circle-completed,.wholesale-static-circle-completed{
    border-radius: 50%;
    position: absolute;
    top: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32%;
    width: 37%;
    border: 1px solid rgba(38,38,19,0.39);;
    font-size: 22px;
    color: #FFFFFF;
    background: rgba(38,38,19,0.39);
    z-index: 9;
  }
  .wholesale-static-circle-completed.text,.wholesale-circle-completed.text{

  }
  .action-area {
    width: 100%;

    h4 {
      transition: all 0.5s;
      position: absolute;
      left: 2%;
      bottom: -65px;
      height: 43px;
      width: 45%;
      background: #000000;
      border: 1px solid #000000;
      box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);
      z-index: 9;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      line-height: 43px;

      i {
        color: #ffffff;
      }

      color: #ffffff;
    }

    .wholesale, .wholesale-static{
      border-radius: 3px;
      position: absolute;
      left: 15%;
      bottom: 75px;
      height: 50px;
      width: 70%;
      background: #F3E93D;
      border: 1px solid #F3E93D;
      box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      line-height: 50px;
      cursor: pointer;

      i {
        color: #262613;
      }

      color: #262613;
    }
    .wholesale-pre-order,.wholesale-static-pre-order {
      border-radius: 3px;
      position: absolute;
      left: 15%;
      bottom: 75px;
      height: 50px;
      width: 70%;
      background: #262613;
      border: 1px solid #262613;
      box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      line-height: 50px;
      cursor: pointer;

      i {
        color: #F3E93D;
      }

      color: #F3E93D;
    }
    .wholesale-completed,.wholesale-static-completed,.wholesale-placed,.wholesale-static-placed{
      border-radius: 3px;
      position: absolute;
      left: 15%;
      bottom: 75px;
      height: 50px;
      width: 70%;
      background: #B9B9B9;
      border: 1px solid #B9B9B9;
      box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      line-height: 50px;
      // cursor: pointer;

      i {
        color: #FFFFFF;
      }

      color: #FFFFFF;
    }
  }
}

// .card {
//   &:hover {
//     .goods h4 {
//       bottom: 20px;
//     }
//   }
// }

.live-price {
  font-size: 18px;
  font-family: Satoshi;
  font-weight: bold;
  line-height: 25px;
  color: #000000;
  opacity: 1;
  margin-right: 10px;
}

.original-price {
  text-decoration: line-through;
  font-size: 14px;
  font-family: Satoshi;
  font-weight: 500;
  line-height: 25px;
  color: #262B2F;
  opacity: 1;
  margin-right: 5px;
}

.price {
  font-size: 14px;
  font-family: Satoshi;
  font-weight: 400;
  line-height: 25px;
  color: #262B2F;
  opacity: 1;
  margin: 15px 0;
}

.discount-tag {
  position: absolute;
  width: 90px;
  height: 28px;
  background: #FF4812;
  opacity: 1;
  color: #ffffff;
  z-index: 8;
  left: 0 !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.vilocal-info {
  display: flex;
  justify-content: space-between;
}

.brand {
  display: inline-flex;
  align-items: center;
}

.brand-logo {
  display: block;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 5px;
  border: solid 1px #e1e1e1;
  cursor: pointer;
}

.brand-name {
  display: block;
  font-size: 18px;
  font-family: Satoshi;
  font-weight: bold;
  line-height: 38px;
  color: #262B2F;
  opacity: 1;
  cursor: pointer;
}

.vilocal-progress {
  width: 40%;

}

.progress {
  //top: 50%;
}

.smail-img-swiper-prev,
.smail-img-swiper-next {
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
  font-weight: bold;
  font-size: 12px;
  color: #000;
  background-color: #F6F5F3;
  padding: 8px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
}

.smail-img-swiper-prev {
  left: 0;
}

.smail-img-swiper-next {
  right: 0;
}

.triangle {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #F3E93D;
  position: relative;
  top: -1px;
}

.progress-info {
  position: relative;
  top: -1px;
  display: inline-block;
  padding: 0 5px;
  background-color: #F3E93D;
  width: auto;
  text-align: center;
  border-radius: 18px;
}

.pageSize {
  width: 100%;
  padding: 30px 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center !important;
}

.el-select {
  width: 70px;
  margin: 0 10px;
}

.page {}

.menu,.menu-checked{
  font-size: 16px;
  font-family: Satoshi-Bold;
  width: 33.333%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-right: 1px solid #E1E1E1;
}
.menu-checked{
  background: #262613;
  color: white;
}
.menu-swiper-div{
  height: 50px;
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  border: 1px solid #E1E1E1;
  border-right: none;
  box-shadow: 0px 3px 6px rgba(0,0,0,0.1);
}
.menu-swiper{
  height: 20px;
}
@media (max-width: 600px) {
  .vilocal-type-tips{
    margin-top: 5px;
  }
  /deep/ .el-menu--horizontal>.el-menu-item{
    height: 48px !important;
  }
  .vilocal-card {
    width: 100%;
    margin-left: 0;
    /* 在移动端，每行渲染1个，宽度为100% */
  }

  .page {}

  .vilocal-root {
    width: 95%;
    margin: 0 auto;
  }

  .wholesale{
    bottom: 60px!important;
  }

  .horizontal-divider{
    margin: 20px 0;
    .black-line{
    width:100%;
  }
  }

  .card-img{
    //aspect-ratio: 1/1 !important;
    aspect-ratio: initial !important;
  }

  .card-detail{
    width:100%;
    height:105vw;
  }
  .img-detail{
    height:95vw;
    width:100%
  }
  .search-box{
    width:100%;
    margin-bottom: 25px;
  }

  .slogan{
    font-size: 14px;
  }
  .grey-line{
    background :#262613;
  }
  .price{
    padding: 15px 0;
    margin:0 !important;
    background-color: #FFFFFF;
    // z-index: 100;
    position: relative;
  }

  .menu-swiper-div{
    width: 100%;
  }
  .swiper-container{
    width: 100%;
  }

  #app > div.vilocal-zone > div.vilocal-zone-main3 > div:nth-child(1) > div.vilocal-root > div.menu-swiper-div > div > div > div:nth-child(3){
    width: 53.5% !important;
  }

  .menu,.menu-checked{
    font-size: 14px;
    width: 48% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/vilocal/vilocal-product.vue